import CloseTrade from "@/views/trades/closed/CloseTrade";
import CloseTradeDetails from "@/views/trades/closed/CloseTradeDetails";

import LiveTrade from "@/views/trades/live/LiveTrade";
import LiveTradeDetails from "@/views/trades/live/LiveTradeDetails";

export default {
  CloseTrade,
  CloseTradeDetails,
  LiveTrade,
  LiveTradeDetails,
};
